import { TIME_FORMAT } from "@constants";
import { IPortInInformation } from "../interface/IPortIn";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { format } from "date-fns";
import { PORT_IN_ROUTE } from "@api-routes/mnpFacade";
import { getStateToPayload } from "../mappers/updatePortInMapper";
import { useFetch } from "@common/hook/useFetch";
import { IPortinForm } from "@features/PortIn/interface/IPortinForm";

export const useSubmitPortIn = (
    closePortIn: () => void,
    getPortIn: (serviceId: number) => void,
    serviceId: number,
    portInDetails?: IPortInInformation
) => {
    const [isFinished, setIsFinished] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [phoneNumberSelected, setPhoneNumberSelected] = useState(portInDetails?.phoneNumber ?? "");
    const [currentProvider, setCurrentProvider] = useState(
        portInDetails?.otherNetworkId
            ? { id: portInDetails.otherNetworkId, networkName: portInDetails.otherNetworkName }
            : undefined
    );
    const [updatePortInState, { post, put }] = useFetch();

    const formMethods = useForm<IPortinForm>({
        defaultValues: {
            accountNumber: portInDetails?.otherNetworkAccountNumber ?? "",
            date: portInDetails?.portStartDateTime ? new Date(portInDetails.portStartDateTime) : null,
            paymentType: portInDetails?.type ?? "",
            phoneNumber: portInDetails?.phoneNumber ?? "",
            time: portInDetails?.portStartDateTime
                ? format(new Date(portInDetails.portStartDateTime), TIME_FORMAT)
                : "",
            validationCode: "",
        },
    });

    const submitPortin = () => {
        const formData = formMethods.getValues();

        if (isFinished && currentProvider && phoneNumberSelected && formData.paymentType) {
            let portInRequest = getStateToPayload(formData, currentProvider.id, phoneNumberSelected, serviceId);

            if (portInDetails) {
                portInRequest = { ...portInRequest, oldId: portInDetails.mnpId };
            }

            const caller = portInDetails ? put : post;
            caller<boolean>(PORT_IN_ROUTE, { body: portInRequest }).then((result) => {
                if (result) {
                    closePortIn();
                    getPortIn(serviceId);
                }
                setIsModalOpen(false);
            });
        }
    };

    return {
        submitPortin,
        updatePortInState,
        setIsFinished,
        currentProvider,
        setCurrentProvider,
        formMethods,
        phoneNumberSelected,
        setPhoneNumberSelected,
        isFinished,
        isModalOpen,
        setIsModalOpen,
    };
};
